export const DELETE_RETURN_REQUEST = 'delete-return-request';

export const CONFIRMATION_DIALOG = {
  delete: {
    title: 'Delete Request?',
    description:
      'On clicking Confirm, the selected return request will be declined and removed. Do you confirm?'
  }
};
